// Import głównego pliku stylów
import '../css/style.scss';

// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

// Import header offset
import { initHeaderOffset, initGalleryTabsOffset } from './header-offset';

// Import WhyUs rotator
import './whyus-rotator';

class App {
    /**
     * Smooth scroll for same-page anchor links (#id)
     */
    initSmoothScrollAnchors() {
        document.addEventListener('click', (event) => {
            if (event.defaultPrevented) return;
            if (event.button !== 0) return;
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

            const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
            if (!link) return;
            if (link.target && link.target.toLowerCase() === '_blank') return;
            if (link.hasAttribute('download')) return;

            const href = link.getAttribute('href');
            if (!href) return;

            let url;
            try {
                url = new URL(href, window.location.href);
            } catch (e) {
                return;
            }

            const hash = url.hash;
            if (!hash || hash === '#') return;

            const sameDocument =
                url.origin === window.location.origin &&
                url.pathname === window.location.pathname &&
                url.search === window.location.search;
            if (!sameDocument) return;

            const rawId = hash.slice(1);
            const decodedId = decodeURIComponent(rawId);

            const targetById = document.getElementById(decodedId);
            const targetByName = !targetById
                ? document.querySelector(`a[name="${CSS && CSS.escape ? CSS.escape(decodedId) : decodedId}"]`)
                : null;
            const target = targetById || targetByName;
            if (!target) return;

            event.preventDefault();

            const header = document.querySelector('.js-headroom');
            const headerOffset = header ? header.offsetHeight : 0;
            const targetTop = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

            const prefersReducedMotion =
                window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({
                top: Math.max(0, targetTop),
                behavior: prefersReducedMotion ? 'auto' : 'smooth',
            });

            if (window.history && window.history.pushState) {
                window.history.pushState(null, '', hash);
            }
        });
    }

    /**
     * Animations On Scroll (AOS)
     */
    initAos() {
        AOS.init({
            duration: 800, // Czas trwania animacji w ms
            easing: 'ease-out-cubic', // Typ easingu
            once: true, // Animacja tylko raz
            offset: 100, // Offset od góry w px
            delay: 0, // Opóźnienie w ms
            anchorPlacement: 'top-bottom', // Punkt zakotwiczenia
            disable: function() {
                // Wyłącz na urządzeniach mobilnych jeśli chcesz
                return window.innerWidth < 768;
            }
        });
        
        console.log('AOS zainicjalizowane');
    }
    
    /**
     * Init headroom.js
     */
    initHeadroom() {
        const headerElement = document.querySelector('.js-headroom');
        if (headerElement && typeof window.Headroom === 'function') {
            var headroom = new Headroom(headerElement);
            headroom.init();
        } else {
            if (!headerElement) {
                console.warn('Element .js-headroom nie został znaleziony');
            }
            if (typeof window.Headroom === 'undefined') {
                console.warn('Headroom library nie jest dostępna');
            }
        }
    }
    
    /**
     * Init viewer.js
     */
    initViewer() {
        const lightBoxes = document.querySelectorAll('.viewer-js');
        if (lightBoxes.length > 0 && typeof window.Viewer === 'function') {
            lightBoxes.forEach(lightBox => {
                const viewer = new Viewer(lightBox, {
                    title: false,
                });
            });
        } else {
            if (lightBoxes.length === 0) {
                console.log('Brak elementów .viewer-js na stronie');
            }
            if (typeof window.Viewer === 'undefined') {
                console.warn('Viewer library nie jest dostępna');
            }
        }
    }
    
    /**
     * Class toggler
     */
    activeClassToggler() {
        const togglers = document.querySelectorAll('.-js-toggler');
        if (togglers) {
            togglers.forEach(toggler => {
                toggler.addEventListener('click', () => {
                    toggler.classList.toggle('active');
                });
            });
        }
    }
    
    /**
     * Execute on page ready
     */
    pageReady() {
        document.body.classList.add('loaded');
        document.body.classList.remove("preload");
    }
    
    reinit() {
        this.initAos();
    }
    
    init() {
        this.initAos();
        this.initHeadroom();
        this.initViewer();
        this.initSmoothScrollAnchors();
        this.activeClassToggler();
        this.pageReady();
        initHeaderOffset();
        initGalleryTabsOffset();
    }
}

// Inicjalizuj od razu gdy DOM jest gotowy
document.addEventListener('DOMContentLoaded', function() {
    const app = new App();
    app.init();
});

// Automatyczny import wszystkich plików JS (oprócz _app.js)
function requireAll(r) {
    r.keys().forEach(r);
}

// Import wszystkich plików JS z aktualnego folderu (oprócz lib/ i _app.js)
requireAll(require.context('./', false, /^(?!.*\/_app\.js$).*\.js$/));
 